import { FormData } from '../../../types/transaction';

interface DatesFormProps {
  formData: FormData;
  onChange: (data: FormData) => void;
}

export default function DatesForm({ formData, onChange }: DatesFormProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-gray-900">Dates</h3>
      
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date du compromis
          </label>
          <input
            type="date"
            value={formData.compromise_date}
            onChange={(e) => onChange({ ...formData, compromise_date: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/50"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date prévisionnelle de l'acte
          </label>
          <input
            type="date"
            value={formData.expected_acte_date}
            onChange={(e) => onChange({ ...formData, expected_acte_date: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/50"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date de signature de l'acte
          </label>
          <input
            type="date"
            value={formData.acte_date}
            onChange={(e) => onChange({ ...formData, acte_date: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/50"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date de facture
          </label>
          <input
            type="date"
            value={formData.invoice_date}
            onChange={(e) => onChange({ ...formData, invoice_date: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/50"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Numéro de facture
          </label>
          <input
            type="text"
            value={formData.invoice_number}
            onChange={(e) => onChange({ ...formData, invoice_number: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/50"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date d'encaissement
          </label>
          <input
            type="date"
            value={formData.encaissement_date}
            onChange={(e) => onChange({ ...formData, encaissement_date: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/50"
          />
        </div>
      </div>
    </div>
  );
}